export default "__VITE_ASSET__C84Gv5RO__"